module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Raúl Nabarret","title":"Raul","short_name":"Raúl Nabarret","start_url":"/","background_color":"#ffffff","theme_color":"#663399","display":"standalone","icon":"src/images/R.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"d39c83843daa193e7e1f960d75d93e99"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
